import React, { PropTypes, Component } from 'react';
import shallowCompare from 'react-addons-shallow-compare';
import { connect } from 'react-redux';
import ReactCSSTransitionReplace from 'react-css-transition-replace';

import { doClock } from '../../store/employees/actions';
import { setActivity, forwardActivity, backwardActivity, clear as clearUser,
  setPasscode } from '../../store/currentUser/actions';
import { clearAdminPasscode, setFirstTimeClockingIn, clearFirstTimeClockingIn }
  from '../../store/config/actions';
import { decrementDeveloper, clearSelf as clearDevice }
  from '../../store/device/actions';
import { prepareLeavePage, submitLeaveRequest, submitUnavailabilityRequest }
  from '../../store/requests/actions';
import { clearSelf as clearAccount, registerOnIntercom, signUpRecordConversion } from '../../store/account/actions';
import { remove as removeNotification, clear as clearNotifications }
  from '../../store/messages/notifications/actions';
import { removeByType as removeSystemMessageByType }
  from '../../store/messages/systemMessages/actions';
import { toggleFeature } from '../../store/settings/features/actions';
import { clearStore as clearAll } from '../../store/index';
import Banner from '../../components/shared/banner';

import UserHub from './userhub/main';
import { Header } from '../shared';
import Keypad from './keypad';

import './styles.scss';

export class TimeclockComponent extends Component {
  constructor(props) {
    super(props);
    this.timeoutDescriptor = null;
    this.timeout = 5000;
    this.setAndStartTimer = this.setAndStartTimer.bind(this);
    this.isFirstTimeClockIn = this.isFirstTimeClockIn.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    const nu = nextProps.currentUser;
    const u = this.props.currentUser;

    if (u && u.valid && u.activities &&
       nu && nu.valid && nu.activities &&
       u.activities.length === nu.activities.length &&
       u.activities[0] === nu.activities[0]) {
      return false;
    }

    // https://facebook.github.io/react/docs/shallow-compare.html
    return shallowCompare(this, nextProps, nextState);
  }

  componentWillUnmount() {
    this.clearTimer();
  }

  setAndStartTimer(timeout) {
    this.timeout = timeout || this.timeout; // if it hasn't changed
    this.clearTimer();
    this.startTimer();
  }

  keypadOrUserHub() {
    if (this.shouldShowUserhub()) {
      return (
        <UserHub
          {...this.props}
          key={1}
          setAndStartTimer={this.setAndStartTimer}
          clearTimer={this.clearTimer}
        />
      );
    }
    return (
      <Keypad
        {...this.props}
        setAndStartTimer={this.setAndStartTimer}
        key={2}
        isFirstTimeClockIn={this.isFirstTimeClockIn}
      />
    );
  }

  handleClick() {
    this.clearTimer();
    this.startTimer();
  }

  clearTimer() {
    clearTimeout(this.timeoutDescriptor);
  }

  isFirstTimeClockIn() {
    return this.props.config && this.props.config.adminFirstClockIn;
  }

  shouldShowUserhub() {
    const { currentUser } = this.props;
    return (currentUser
      && currentUser.valid
      && currentUser.activities
      && currentUser.activities.length > 0
    );
  }

  startTimer() {
    this.timeoutDescriptor = setTimeout(() => {
      if (!__DEV__) { // only clear the user in production mode
        if (!this.isFirstTimeClockIn()) {
          this.props.clearUser();
        }
      } else {
        console.log('Timer would have expired');
      }
    }, this.timeout);
  }

  /**
   * Renders the component to DOM.
   * COMPONENT LIFECYCLE HOOK (See React.js docs)
   * @return {Element} returns the element composition of the component.
   */
  render() {
    return (
      <div id='timeclock' onClick={() => this.handleClick()}>
        <Banner />
        <Header location={this.props.device.location.name} />
        <ReactCSSTransitionReplace
          component='div'
          className='timeclockAnimations'
          transitionName='timeclockFade'
          transitionAppear
          transitionEnterTimeout={250}
          transitionLeaveTimeout={250}
          transitionAppearTimeout={250}
        >
          {this.keypadOrUserHub()}
        </ReactCSSTransitionReplace>
      </div>
    );
  }
}

TimeclockComponent.propTypes = {
  account: PropTypes.object,
  device: PropTypes.object,
  currentUser: PropTypes.object,
  registerOnIntercom: PropTypes.func,
  signUpRecordConversion: PropTypes.func,
  clearUser: PropTypes.func,
  config: PropTypes.shape({
    passcodeValidated: PropTypes.bool,
    adminPasscode: PropTypes.string,
    adminFirstClockIn: PropTypes.bool,
  }),
};

/**
 * Maps the components props to the relevant part of application state.
 * @param  {Map} state: the applications state
 * @return {Object} the components props mapped to their locations's state.
 */
function mapToState(state) {
  return {
    account: state.get('account').toJS(),
    device: state.get('device').toJS(),
    currentUser: state.get('currentUser').toJS(),
    shiftDetails: state.getIn(['shiftDetails']).toJS(),
    teams: state.get('teams').toJS(),
    notifications: state.getIn(['messages', 'notifications']).toJS(),
    systemMessages: state.getIn(['messages', 'systemMessages']).toJS(),
    settings: state.getIn(['settings', 'organisation']).toJS(),
    features: state.getIn(['settings', 'features']).toJS(),
    config: state.get('config').toJS(),
    clearAll,
  };
}

/**
 * The connected component
 * @param  {Function} mapToState: the function returning the properties mapped
 * to their locations
 * @param  {Function} actions: the function with all properties mapped to
 * the componented actions.
 * @return {Class} the connected component
 */
export const Timeclock = connect(mapToState, {
  setActivity,
  clearAdminPasscode,
  setFirstTimeClockingIn,
  clearFirstTimeClockingIn,
  forwardActivity,
  backwardActivity,
  clearUser,
  doClock,
  decrementDeveloper,
  prepareLeavePage,
  submitLeaveRequest,
  submitUnavailabilityRequest,
  removeNotification,
  removeSystemMessageByType,
  clearNotifications,
  toggleFeature,
  clearDevice,
  clearAccount,
  registerOnIntercom,
  setPasscode,
  signUpRecordConversion,
})(TimeclockComponent);



// WEBPACK FOOTER //
// ./src/components/timeclock/main.jsx